import { translateLabel } from "@/i18n/messages";
export const registrationPasswordError = (password, confirmation) => {
  if (password.length < 8) return "Password must have at least 8 characters";
  if (password !== confirmation) return "Passwords do not match";
  return null;
};
